import React from 'react';
import SendMessage from './SendMessage';
import { PageInstructions } from '../../../content/StepContent';

const MessagePage = () => {
    let title = PageInstructions.title;
    let subtitle = PageInstructions.subtitle;

    return (
        <div>
            <div className="app__page-title__container">
                <div className="app__page-title">{title}</div>
                <div className="push-down-10" dangerouslySetInnerHTML={{ __html: subtitle }}></div>
            </div>
            <div className="app__message-page__container">
                <SendMessage />
            </div>
        </div>
    );
};

export default MessagePage;
